/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupssaved1Inputs */

const en_groupssaved1 = /** @type {(inputs: Groupssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_groupssaved1 = /** @type {(inputs: Groupssaved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Groupssaved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssaved1 = /** @type {((inputs?: Groupssaved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssaved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssaved1(inputs)
	return de_groupssaved1(inputs)
});
export { groupssaved1 as "groupsSaved" }